import { render } from "./LazyImage.vue?vue&type=template&id=5fa0e1ea&ts=true"
import script from "./LazyImage.vue?vue&type=script&lang=ts"
export * from "./LazyImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__